import { ValueFunction } from '../../';

function methodProductTimesX({constant=1, args=[]}) {
  if (constant !== null && args.every(v => v !== null)) {
    return args.reduce((a,b) => a*b, constant);
  } else {
    return null;
  }
}

export const productTimesX = new ValueFunction(
  methodProductTimesX,
  {
    label: 'Product of n-Series with a Constant',
    description: 'constant * args0 * args1 * ... * argsN',
    parameters: [
      {'name': 'constant', 'type': 'number', 'default': 1},
      {'name': 'args', 'type': 'array:number'}
    ],
    maxLength: Infinity
  }
);